var _rect, _text, _text2, _rect2, _text3, _rect3, _rect4, _path, _line, _line2, _line3, _line4, _text4, _text5, _circle, _text6, _text7, _rect5, _text8, _text9, _circle2, _text0, _text1, _text10, _circle3, _text11, _text12, _text13, _circle4, _text14, _text15, _line5, _text16, _rect6, _text17, _rect7, _text18, _rect8, _text19, _rect9, _text20, _line6, _text21, _rect0, _text22, _text23, _rect1, _text24, _text25, _rect10, _text26, _text27, _rect11, _text28, _text29, _line7, _text30, _rect12, _text31, _text32, _rect13, _text33, _text34, _rect14, _text35, _text36, _rect15, _text37, _text38, _line8, _text39, _rect16, _text40, _text41, _rect17, _text42, _text43, _rect18, _text44, _text45, _rect19, _text46, _text47, _line9, _text48, _rect20, _text49, _text50, _rect21, _text51, _text52, _rect22, _text53, _text54, _rect23, _text55, _text56, _line0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCandidateComparison = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 2040 1170",
  width: 2040,
  height: 1170,
  xmlns: "http://www.w3.org/2000/svg",
  fontFamily: "Arial, Helvetica, sans-serif",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0,
  y: 0,
  width: 2040,
  height: 1170,
  fill: "#f1f5f9"
})), _text || (_text = /*#__PURE__*/React.createElement("text", {
  x: 14,
  y: 42,
  fontSize: 38,
  fontWeight: 900,
  fill: "#0f172a"
}, "Candidate Comparison")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
  x: 14,
  y: 80,
  fontSize: 22,
  fill: "#94a3b8"
}, "Comparing 4 candidates for Lead Developer")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 1806,
  y: 14,
  width: 222,
  height: 52,
  rx: 10,
  fill: "white",
  stroke: "#e2e8f0",
  strokeWidth: 1.5
})), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
  x: 1836,
  y: 47,
  fontSize: 20,
  fontWeight: 700,
  fill: "#0f172a"
}, "Clear Selection")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 8,
  y: 120,
  width: 2024,
  height: 1046,
  rx: 16,
  fill: "white",
  stroke: "#e2e8f0",
  strokeWidth: 1.5
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  x: 487,
  y: 120,
  width: 1159,
  height: 272,
  fill: "#f8fafc"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M 487 136 Q 487 120 503 120 L 1630 120 Q 1646 120 1646 136 L 1646 392 L 487 392 Z",
  fill: "#f8fafc"
})), _line || (_line = /*#__PURE__*/React.createElement("line", {
  x1: 487,
  y1: 120,
  x2: 487,
  y2: 1166,
  stroke: "#e2e8f0"
})), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
  x1: 873,
  y1: 120,
  x2: 873,
  y2: 1166,
  stroke: "#e2e8f0"
})), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
  x1: 1260,
  y1: 120,
  x2: 1260,
  y2: 1166,
  stroke: "#e2e8f0"
})), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
  x1: 1646,
  y1: 120,
  x2: 1646,
  y2: 1166,
  stroke: "#e2e8f0"
})), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
  x: 39,
  y: 266,
  fontSize: 26,
  fontWeight: 800,
  fill: "#0f172a"
}, "Dimension")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
  x: 849,
  y: 158,
  fontSize: 22,
  fill: "#94a3b8",
  textAnchor: "middle"
}, "\xD7")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 680,
  cy: 202,
  r: 38,
  fill: "#3b5bfd"
})), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
  x: 680,
  y: 213,
  fontSize: 26,
  fontWeight: 800,
  fill: "white",
  textAnchor: "middle"
}, "MC")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
  x: 680,
  y: 280,
  fontSize: 28,
  fontWeight: 800,
  fill: "#0f172a",
  textAnchor: "middle"
}, "Maya Chen")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  x: 610,
  y: 298,
  width: 140,
  height: 42,
  rx: 21,
  fill: "#dcfce7"
})), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
  x: 680,
  y: 325,
  fontSize: 19,
  fontWeight: 700,
  fill: "#16a34a",
  textAnchor: "middle"
}, "Best Match")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
  x: 1236,
  y: 158,
  fontSize: 22,
  fill: "#94a3b8",
  textAnchor: "middle"
}, "\xD7")), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 1066.5,
  cy: 202,
  r: 38,
  fill: "#3b5bfd"
})), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
  x: 1066.5,
  y: 213,
  fontSize: 26,
  fontWeight: 800,
  fill: "white",
  textAnchor: "middle"
}, "DR")), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
  x: 1066.5,
  y: 280,
  fontSize: 28,
  fontWeight: 800,
  fill: "#0f172a",
  textAnchor: "middle"
}, "Devon Reyes")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
  x: 1622,
  y: 158,
  fontSize: 22,
  fill: "#94a3b8",
  textAnchor: "middle"
}, "\xD7")), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 1453,
  cy: 202,
  r: 38,
  fill: "#3b5bfd"
})), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
  x: 1453,
  y: 213,
  fontSize: 26,
  fontWeight: 800,
  fill: "white",
  textAnchor: "middle"
}, "PN")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
  x: 1453,
  y: 280,
  fontSize: 28,
  fontWeight: 800,
  fill: "#0f172a",
  textAnchor: "middle"
}, "Priya Nair")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
  x: 2008,
  y: 158,
  fontSize: 22,
  fill: "#94a3b8",
  textAnchor: "middle"
}, "\xD7")), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 1839,
  cy: 202,
  r: 38,
  fill: "#3b5bfd"
})), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
  x: 1839,
  y: 213,
  fontSize: 26,
  fontWeight: 800,
  fill: "white",
  textAnchor: "middle"
}, "MW")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
  x: 1839,
  y: 280,
  fontSize: 28,
  fontWeight: 800,
  fill: "#0f172a",
  textAnchor: "middle"
}, "Marcus Webb")), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
  x1: 8,
  y1: 392,
  x2: 2032,
  y2: 392,
  stroke: "#e2e8f0"
})), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
  x: 39,
  y: 462,
  fontSize: 26,
  fontWeight: 800,
  fill: "#0f172a"
}, "Score ", /*#__PURE__*/React.createElement("tspan", {
  fontSize: 20,
  fill: "#94a3b8"
}, "\u2195"))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  x: 632,
  y: 422,
  width: 96,
  height: 64,
  rx: 32,
  fill: "#3b5bfd"
})), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
  x: 680,
  y: 464,
  fontSize: 30,
  fontWeight: 800,
  fill: "white",
  textAnchor: "middle"
}, "88")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  x: 1018.5,
  y: 422,
  width: 96,
  height: 64,
  rx: 32,
  fill: "#3b5bfd"
})), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
  x: 1066.5,
  y: 464,
  fontSize: 30,
  fontWeight: 800,
  fill: "white",
  textAnchor: "middle"
}, "79")), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
  x: 1405,
  y: 422,
  width: 96,
  height: 64,
  rx: 32,
  fill: "#3b5bfd"
})), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
  x: 1453,
  y: 464,
  fontSize: 30,
  fontWeight: 800,
  fill: "white",
  textAnchor: "middle"
}, "74")), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
  x: 1791,
  y: 422,
  width: 96,
  height: 64,
  rx: 32,
  fill: "#3b5bfd"
})), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
  x: 1839,
  y: 464,
  fontSize: 30,
  fontWeight: 800,
  fill: "white",
  textAnchor: "middle"
}, "68")), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
  x1: 8,
  y1: 516,
  x2: 2032,
  y2: 516,
  stroke: "#e2e8f0"
})), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
  x: 39,
  y: 605.5,
  fontSize: 26,
  fontWeight: 800,
  fill: "#0f172a"
}, "Communication")), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
  x: 641,
  y: 552,
  width: 78,
  height: 52,
  rx: 26,
  fill: "#dcfce7"
})), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
  x: 680,
  y: 587,
  fontSize: 26,
  fontWeight: 800,
  fill: "#16a34a",
  textAnchor: "middle"
}, "91")), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
  x: 680,
  y: 655,
  fontSize: 20,
  fill: "#94a3b8",
  textAnchor: "middle"
}, "Exceeds")), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
  x: 1027.5,
  y: 552,
  width: 78,
  height: 52,
  rx: 26,
  fill: "#fef3c7"
})), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
  x: 1066.5,
  y: 587,
  fontSize: 26,
  fontWeight: 800,
  fill: "#b45309",
  textAnchor: "middle"
}, "82")), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
  x: 1066.5,
  y: 655,
  fontSize: 20,
  fill: "#94a3b8",
  textAnchor: "middle"
}, "Meets")), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
  x: 1414,
  y: 552,
  width: 78,
  height: 52,
  rx: 26,
  fill: "#fef3c7"
})), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
  x: 1453,
  y: 587,
  fontSize: 26,
  fontWeight: 800,
  fill: "#b45309",
  textAnchor: "middle"
}, "78")), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
  x: 1453,
  y: 655,
  fontSize: 20,
  fill: "#94a3b8",
  textAnchor: "middle"
}, "Meets")), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
  x: 1800,
  y: 552,
  width: 78,
  height: 52,
  rx: 26,
  fill: "#fee2e2"
})), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
  x: 1839,
  y: 587,
  fontSize: 26,
  fontWeight: 800,
  fill: "#e11d48",
  textAnchor: "middle"
}, "70")), _text29 || (_text29 = /*#__PURE__*/React.createElement("text", {
  x: 1839,
  y: 655,
  fontSize: 20,
  fill: "#94a3b8",
  textAnchor: "middle"
}, "Below")), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
  x1: 8,
  y1: 679,
  x2: 2032,
  y2: 679,
  stroke: "#e2e8f0"
})), _text30 || (_text30 = /*#__PURE__*/React.createElement("text", {
  x: 39,
  y: 768.5,
  fontSize: 26,
  fontWeight: 800,
  fill: "#0f172a"
}, "Work Level")), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
  x: 641,
  y: 715,
  width: 78,
  height: 52,
  rx: 26,
  fill: "#dcfce7"
})), _text31 || (_text31 = /*#__PURE__*/React.createElement("text", {
  x: 680,
  y: 750,
  fontSize: 26,
  fontWeight: 800,
  fill: "#16a34a",
  textAnchor: "middle"
}, "86")), _text32 || (_text32 = /*#__PURE__*/React.createElement("text", {
  x: 680,
  y: 818,
  fontSize: 20,
  fill: "#94a3b8",
  textAnchor: "middle"
}, "Exceeds")), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
  x: 1027.5,
  y: 715,
  width: 78,
  height: 52,
  rx: 26,
  fill: "#fef3c7"
})), _text33 || (_text33 = /*#__PURE__*/React.createElement("text", {
  x: 1066.5,
  y: 750,
  fontSize: 26,
  fontWeight: 800,
  fill: "#b45309",
  textAnchor: "middle"
}, "75")), _text34 || (_text34 = /*#__PURE__*/React.createElement("text", {
  x: 1066.5,
  y: 818,
  fontSize: 20,
  fill: "#94a3b8",
  textAnchor: "middle"
}, "Meets")), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
  x: 1414,
  y: 715,
  width: 78,
  height: 52,
  rx: 26,
  fill: "#fee2e2"
})), _text35 || (_text35 = /*#__PURE__*/React.createElement("text", {
  x: 1453,
  y: 750,
  fontSize: 26,
  fontWeight: 800,
  fill: "#e11d48",
  textAnchor: "middle"
}, "71")), _text36 || (_text36 = /*#__PURE__*/React.createElement("text", {
  x: 1453,
  y: 818,
  fontSize: 20,
  fill: "#94a3b8",
  textAnchor: "middle"
}, "Below")), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
  x: 1800,
  y: 715,
  width: 78,
  height: 52,
  rx: 26,
  fill: "#fee2e2"
})), _text37 || (_text37 = /*#__PURE__*/React.createElement("text", {
  x: 1839,
  y: 750,
  fontSize: 26,
  fontWeight: 800,
  fill: "#e11d48",
  textAnchor: "middle"
}, "65")), _text38 || (_text38 = /*#__PURE__*/React.createElement("text", {
  x: 1839,
  y: 818,
  fontSize: 20,
  fill: "#94a3b8",
  textAnchor: "middle"
}, "Below")), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
  x1: 8,
  y1: 842,
  x2: 2032,
  y2: 842,
  stroke: "#e2e8f0"
})), _text39 || (_text39 = /*#__PURE__*/React.createElement("text", {
  x: 39,
  y: 931.5,
  fontSize: 26,
  fontWeight: 800,
  fill: "#0f172a"
}, "Execution")), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
  x: 641,
  y: 878,
  width: 78,
  height: 52,
  rx: 26,
  fill: "#dcfce7"
})), _text40 || (_text40 = /*#__PURE__*/React.createElement("text", {
  x: 680,
  y: 913,
  fontSize: 26,
  fontWeight: 800,
  fill: "#16a34a",
  textAnchor: "middle"
}, "89")), _text41 || (_text41 = /*#__PURE__*/React.createElement("text", {
  x: 680,
  y: 981,
  fontSize: 20,
  fill: "#94a3b8",
  textAnchor: "middle"
}, "Exceeds")), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
  x: 1027.5,
  y: 878,
  width: 78,
  height: 52,
  rx: 26,
  fill: "#fef3c7"
})), _text42 || (_text42 = /*#__PURE__*/React.createElement("text", {
  x: 1066.5,
  y: 913,
  fontSize: 26,
  fontWeight: 800,
  fill: "#b45309",
  textAnchor: "middle"
}, "77")), _text43 || (_text43 = /*#__PURE__*/React.createElement("text", {
  x: 1066.5,
  y: 981,
  fontSize: 20,
  fill: "#94a3b8",
  textAnchor: "middle"
}, "Meets")), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
  x: 1414,
  y: 878,
  width: 78,
  height: 52,
  rx: 26,
  fill: "#fef3c7"
})), _text44 || (_text44 = /*#__PURE__*/React.createElement("text", {
  x: 1453,
  y: 913,
  fontSize: 26,
  fontWeight: 800,
  fill: "#b45309",
  textAnchor: "middle"
}, "76")), _text45 || (_text45 = /*#__PURE__*/React.createElement("text", {
  x: 1453,
  y: 981,
  fontSize: 20,
  fill: "#94a3b8",
  textAnchor: "middle"
}, "Meets")), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
  x: 1800,
  y: 878,
  width: 78,
  height: 52,
  rx: 26,
  fill: "#fee2e2"
})), _text46 || (_text46 = /*#__PURE__*/React.createElement("text", {
  x: 1839,
  y: 913,
  fontSize: 26,
  fontWeight: 800,
  fill: "#e11d48",
  textAnchor: "middle"
}, "69")), _text47 || (_text47 = /*#__PURE__*/React.createElement("text", {
  x: 1839,
  y: 981,
  fontSize: 20,
  fill: "#94a3b8",
  textAnchor: "middle"
}, "Below")), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
  x1: 8,
  y1: 1005,
  x2: 2032,
  y2: 1005,
  stroke: "#e2e8f0"
})), _text48 || (_text48 = /*#__PURE__*/React.createElement("text", {
  x: 39,
  y: 1094.5,
  fontSize: 26,
  fontWeight: 800,
  fill: "#0f172a"
}, "Critical Thinking")), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
  x: 641,
  y: 1041,
  width: 78,
  height: 52,
  rx: 26,
  fill: "#dcfce7"
})), _text49 || (_text49 = /*#__PURE__*/React.createElement("text", {
  x: 680,
  y: 1076,
  fontSize: 26,
  fontWeight: 800,
  fill: "#16a34a",
  textAnchor: "middle"
}, "87")), _text50 || (_text50 = /*#__PURE__*/React.createElement("text", {
  x: 680,
  y: 1144,
  fontSize: 20,
  fill: "#94a3b8",
  textAnchor: "middle"
}, "Exceeds")), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
  x: 1027.5,
  y: 1041,
  width: 78,
  height: 52,
  rx: 26,
  fill: "#fef3c7"
})), _text51 || (_text51 = /*#__PURE__*/React.createElement("text", {
  x: 1066.5,
  y: 1076,
  fontSize: 26,
  fontWeight: 800,
  fill: "#b45309",
  textAnchor: "middle"
}, "81")), _text52 || (_text52 = /*#__PURE__*/React.createElement("text", {
  x: 1066.5,
  y: 1144,
  fontSize: 20,
  fill: "#94a3b8",
  textAnchor: "middle"
}, "Meets")), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
  x: 1414,
  y: 1041,
  width: 78,
  height: 52,
  rx: 26,
  fill: "#fee2e2"
})), _text53 || (_text53 = /*#__PURE__*/React.createElement("text", {
  x: 1453,
  y: 1076,
  fontSize: 26,
  fontWeight: 800,
  fill: "#e11d48",
  textAnchor: "middle"
}, "72")), _text54 || (_text54 = /*#__PURE__*/React.createElement("text", {
  x: 1453,
  y: 1144,
  fontSize: 20,
  fill: "#94a3b8",
  textAnchor: "middle"
}, "Below")), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
  x: 1800,
  y: 1041,
  width: 78,
  height: 52,
  rx: 26,
  fill: "#fee2e2"
})), _text55 || (_text55 = /*#__PURE__*/React.createElement("text", {
  x: 1839,
  y: 1076,
  fontSize: 26,
  fontWeight: 800,
  fill: "#e11d48",
  textAnchor: "middle"
}, "67")), _text56 || (_text56 = /*#__PURE__*/React.createElement("text", {
  x: 1839,
  y: 1144,
  fontSize: 20,
  fill: "#94a3b8",
  textAnchor: "middle"
}, "Below")), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
  x1: 8,
  y1: 1168,
  x2: 2032,
  y2: 1168,
  stroke: "#e2e8f0"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCandidateComparison);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/candidate-comparison.4d4ac4d802f348b0f657ea20759c870c.svg";